import { Button as Buttons } from 'primereact/button';  

const Button = ({...rest}) => {

    return (
        <Buttons {...rest} />
    )

};

export default Button;